module.exports = __webpack_public_path__ + "img/banner_ibama.818ddedc.png";